import { Menu } from "@base-ui/react/menu"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const ActionMenuItem = ({ label, icon, onClick, href, disabled }) => {
  const styles = classNames(
    "flex w-full items-center gap-2 px-3 py-2 text-sm text-left text-gray-700 no-underline hover:no-underline",
    disabled
      ? "opacity-50 cursor-not-allowed"
      : "cursor-pointer hover:bg-gray-100"
  )

  const content = (
    <>
      {icon && (
        <div className="flex w-6 justify-center text-center">
          <i className={`icon icon-${icon} text-base`} />
        </div>
      )}
      {label}
    </>
  )

  if (href) {
    return (
      <Menu.Item
        render={<a href={href} />}
        className={styles}
        disabled={disabled}
      >
        {content}
      </Menu.Item>
    )
  }

  return (
    <Menu.Item onClick={onClick} className={styles} disabled={disabled}>
      {content}
    </Menu.Item>
  )
}

ActionMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  disabled: PropTypes.bool,
}

const ActionMenu = ({
  items,
  triggerIcon = "dots-vertical",
  triggerLabel = "Actions",
  side = "bottom",
  align = "end",
  onOpenChange,
}) => {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <Menu.Root onOpenChange={onOpenChange}>
      <Menu.Trigger
        aria-label={triggerLabel}
        className="flex cursor-pointer items-center justify-center rounded bg-white p-0 hover:bg-gray-200"
      >
        <i className={`icon icon-${triggerIcon} text-xl text-gray-900`} />
      </Menu.Trigger>

      <Menu.Portal>
        <Menu.Positioner
          side={side}
          align={align}
          sideOffset={4}
          className="z-[100]"
        >
          <Menu.Popup className="min-w-44 rounded border bg-white py-1 shadow-lg">
            {items.map((item, index) => (
              <ActionMenuItem key={item.label} {...item} />
            ))}
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  )
}

ActionMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func,
      href: PropTypes.string,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  triggerIcon: PropTypes.string,
  triggerLabel: PropTypes.string,
  side: PropTypes.oneOf(["top", "bottom", "left", "right"]),
  align: PropTypes.oneOf(["start", "center", "end"]),
  onOpenChange: PropTypes.func,
}

export default ActionMenu
